import { HttpClient } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { appConfigService } from '@app/config';
import { JedinicaGradiva } from '@app/shared/models/jedinica-gradiva';
import { POSJET } from '@app/shared/models/types';
import {
  AuthRequestOptions,
  ListViewProviderDirective,
  NotificationService
} from '@ntap/core';
import { first } from 'rxjs';

@Component({
  selector: `app-dodaj-jedinice-gradiva-u-zahtjev`,
  templateUrl:
    '../../shared/components/odabir-jedinica-gradiva/odabir-jedinica.component.html'
})
export class DodajJediniceGradivaUZahtjevComponent {
  public showDialog = false;

  private listviewProvider = inject(ListViewProviderDirective);
  private notificationService = inject(NotificationService);

  private httpClient = inject(HttpClient);
  private config = inject(appConfigService);

  public refresh() {
    this.listviewProvider.refresh();
  }

  public onSelectedItem(jedinice: JedinicaGradiva[]) {
    let zahtjevId;

    const viewState: any = this.listviewProvider.viewState;
    if (viewState.$itemType === POSJET) {
      zahtjevId = viewState.$parent['en~posjet~zahtjev_id'];
    } else {
      zahtjevId = (viewState as { $parentId: number })['$parentId'];
    }

    const formData = {
      jediniceGradivaIds: jedinice.map((j) => j['en~jedinica_gradiva~id']),
      zahtjevId: zahtjevId
    };

    this.httpClient
      .post(
        `${this.config.apiHost}jedinice-gradiva-zahtjev`,
        formData,
        new AuthRequestOptions()
      )
      .pipe(first())
      .subscribe({
        next: () => {
          const message =
            jedinice.length > 1
              ? 'Jedinice gradiva uspješno dodane'
              : 'Jedinica gradiva uspješno dodana';
          this.notificationService.success(message);
          this.listviewProvider.refresh();
        },
        error: () => {
          const errorMessage =
            jedinice.length > 1
              ? 'Greška pri dodavanju jedinica gradiva'
              : 'Greška pri dodavanju jedinice gradiva';
          this.notificationService.error(errorMessage);
        },
        complete: () => {
          this.showDialog = false;
        }
      });

    this.showDialog = false;
  }
}
